import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';

// ---------------------------------------------------------

import ContactForm from '@components/form';
import useWindowSize from '@lib/window-size';
import { pushDataLayerEvent } from '@lib/gtm';

// ---------------------------------------------------------

import { container, subheader } from './styles.module.scss';

// ---------------------------------------------------------

const EnhancedContactForm = (props) => {
  const {
    children,
    defaultCommentValue,
    requestType,
    contactText,
    hasTour,
    hasPrimaryAndSecondaryAgent,
    listingId,
    sticky,
    agentIds,
    setModalIsOpen,
    title,
    shouldAllowLeadsPlusAgent,
    realtors
  } = props;

  if (!realtors) return;

  const ref = useRef();
  const [referenceHeight, setReferenceHeight] = useState(0);
  const router = useRouter();
  const onListingPage = router.pathname.startsWith('/listing/');

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'chat-visible' });

    setReferenceHeight(ref.current?.clientHeight || 0);
  }, []);

  // ---------------------------------------------------------

  const primaryAgent = realtors[0];

  return (
    <div
      className={container}
      ref={ref}
      id="isSibcyClineListing"
      style={{
        position: referenceHeight + 50 < useWindowSize().height && sticky ? 'sticky' : 'inherit',
        top: referenceHeight + 50 < useWindowSize().height && sticky ? '20px' : '0px'
      }}
    >
      {children}
      <span className={subheader}>
        {contactText ? (
          <>{contactText}</>
        ) : (
          <>
            Contact{' '}
            {hasPrimaryAndSecondaryAgent
              ? `us`
              : primaryAgent?.nickname || primaryAgent?.displayPrimary}{' '}
            to learn&nbsp;more
          </>
        )}
        {hasTour && onListingPage ? (
          <>
            &nbsp;or&nbsp;
            <button
              onClick={() => {
                pushDataLayerEvent('listing_request_a_tour_modal_click', router.asPath);
                setModalIsOpen(true);
              }}
            >
              {' '}
              request a tour!
            </button>
          </>
        ) : (
          '!'
        )}
      </span>
      <ContactForm
        title={title}
        submitLabel="Send Message"
        requestType={requestType}
        listingId={listingId}
        defaultCommentValue={defaultCommentValue}
        agentIds={agentIds}
        shouldAllowLeadsPlusAgent={shouldAllowLeadsPlusAgent}
      ></ContactForm>
    </div>
  );
};

EnhancedContactForm.propTypes = {
  children: PropTypes.node,
  agentIds: PropTypes.array,
  contactText: PropTypes.string,
  defaultCommentValue: PropTypes.string,
  requestType: PropTypes.string,
  hasPrimaryAndSecondaryAgent: PropTypes.bool,
  hasTour: PropTypes.bool,
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setModalIsOpen: PropTypes.func,
  sticky: PropTypes.bool,
  title: PropTypes.string,
  primaryAgent: PropTypes.object,
  secondaryAgent: PropTypes.object,
  shouldAllowLeadsPlusAgent: PropTypes.bool,
  realtors: PropTypes.array
};

export default EnhancedContactForm;
